import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'
import { useCartStore } from './stores/cart'
import { useWishlistStore } from './stores/wishlist'
import './assets/styles/main.scss'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Initialize stores after app is mounted
app.mount('#app')

// Initialize stores
const authStore = useAuthStore()
const cartStore = useCartStore()
const wishlistStore = useWishlistStore()

// Load guest cart and wishlist from localStorage
cartStore.loadLocalCart()
wishlistStore.loadWishlist()

// Initialize auth (will validate token if exists)
authStore.init().then(() => {
  // If user is authenticated, sync with server
  if (authStore.isAuthenticated) {
    cartStore.fetchCart()
    wishlistStore.fetchWishlist()
  }
})
